export default "__VITE_ASSET__CLPUuCnp__"